<template>
	<div class="face_track">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">视频人证比对与追踪</h1>
		<h2 class="doc_main_h2">视频人证比对（字符串类型人脸特征）</h2>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的BGR24数据进行人脸检测、追踪，并与指定的base64人脸特征字符串进行比对。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">CFaceStruct** __stdcall SKFaceVideoTrackWithBase64Feature(unsigned char *pBGR24Data, 
		const char* pszBase64Feature, int &nFaceNum);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pBGR24Data: 视频帧的BGR倒立数据</p>
        <p class="doc_main_p">（2）pszBase64Feature: base64后的人脸特征字符串</p>
        <p class="doc_main_p">（2）nFaceNum:人脸数量，返回值为1</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	数据结构（数组）（返回结构体指针，里面有nFaceNum个FaceStruct结构体）
		</p>
		<test-result-structure></test-result-structure>
		<p class="doc_main_p">
        	返回人脸数量为1，如果人脸名字为“MatchSucceed“，此时ID为”1000001”则人证比对成功；如果人脸名字为”MatchFailed”，此时ID为”-1000001“，则人证比对失败；其余情况表示正在比对中。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">CFaceStruct **pFacesList = NULL;
int nFaceNum = 0;
pFacesList = SKFaceVideoTrackWithBinFeature(pBGR24Data,pszBase64Feature,nFaceNum);
if(nFaceNum == 0)
{
    return;
}
CFaceStruct *pFace = pFacesList[0];
if(strcmp(pFace->szName,"MatchSucceed") == 0)
{
    // 人证比对成功
}
else if(strcmp(pFace->szName,"MatchFailed") == 0)
{
    // 人证比对失败
}
else
{
    // 正在比对中
}</code></pre>
		<!-- 视频人证比对（unsigned char*类型人脸特征） -->
		<h2 class="doc_main_h2">视频人证比对（unsigned char*类型人脸特征）</h2>
		<!-- <h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的BGR24数据进行人脸检测、追踪，并与指定的base64人脸特征字符串进行比对。
		</p> -->
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">CFaceStruct** __stdcall SKFaceVideoTrackWithBinFeature(unsigned 
		char *pBGRData, const char* pBinFeature, int &nFaceNum);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）pBGR24Data: 视频帧的BGR倒立数据</p>
        <p class="doc_main_p">（2）pBinFeature: 人脸特征</p>
        <p class="doc_main_p">（2）nFaceNum:人脸数量，返回值为1</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	数据结构（数组）（返回结构体指针，里面有nFaceNum个FaceStruct结构体）
		</p>
		<test-result-structure></test-result-structure>
		<p class="doc_main_p">
        	返回人脸数量为1，如果人脸名字为“MatchSucceed“，此时ID为”1000001”则人证比对成功；如果人脸名字为”MatchFailed”，此时ID为”-1000001“，则人证比对失败；其余情况表示正在比对中。
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">CFaceStruct **pFacesList = NULL;
int nFaceNum = 0;
pFacesList = SKFaceVideoTrackWithBinFeature(pBGR24Data,pFeature,nFaceNum);
if(nFaceNum == 0)
{
    return;
}
CFaceStruct *pFace = pFacesList[0];
if(strcmp(pFace->szName,"MatchSucceed") == 0)
{
    // 人证比对成功
}
else if(strcmp(pFace->szName,"MatchFailed") == 0)
{
    // 人证比对失败
}
else
{
    // 正在比对中
}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import TestResultStructure from '../../../../components/testResultStructure';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'test-result-structure':TestResultStructure,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','基础接口','视频人证比对与追踪'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.face_track{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/basics/personCardTrack.vue